import React from 'react';
import PropTypes from 'prop-types';

import { clickAsLink } from 'helpers/link_helpers';
import { fetchProperty } from './api';
import { getItem } from 'helpers/session_storage_helper';

import PaginationButtons from '../pagination_buttons';

const rootPath = '/research/properties';
const allPropertiesIds = getItem("researchPropertiesIds", []);

export default class PropertiesPaginationButtons extends React.Component {
  static propTypes = {
    currentIndex: PropTypes.number,
    propertyId: PropTypes.number.isRequired
  };

  state = {
    prevIndex: null,
    nextIndex: null
  }

  componentDidMount() {
    const { currentIndex } = this.props;

    if (currentIndex != null && allPropertiesIds.length > 0) {
      this.prevProperty(currentIndex - 1);
      this.nextProperty(currentIndex + 1);
    }
  }

  handleClick = (e, index) => {
    if (index >= 0 && index < allPropertiesIds.length) {
      clickAsLink(window, `${rootPath}/${allPropertiesIds[index]}?offset=${index}`, e);
    }
  }

  nextProperty = (nextIndex) => {
    if (nextIndex < allPropertiesIds.length && nextIndex != null)  {
      if (allPropertiesIds[nextIndex] === undefined) return;
      fetchProperty(allPropertiesIds[nextIndex]).then(() => {
        this.setState({ nextIndex: nextIndex });
      }).catch(() => {
        // this.nextProperty(nextIndex++);
      });
    }
  }

  prevProperty = (prevIndex) => {
    if (prevIndex >= 0 && prevIndex != null) {
      if (allPropertiesIds[prevIndex] === undefined) return;
      fetchProperty(allPropertiesIds[prevIndex]).then(() => {
        this.setState({ prevIndex: prevIndex });
      }).catch(() => {
        // this.prevProperty(prevIndex--);
      });
    }
  }

  render() {
    const { currentIndex, propertyId } = this.props;
    const { nextIndex, prevIndex } = this.state;

    if (currentIndex != null) {
      return (
        <PaginationButtons
          allIds={allPropertiesIds}
          currentIndex={currentIndex}
          entityId={propertyId}
          nextIndex={nextIndex}
          prevIndex={prevIndex}
          onClick={this.handleClick}
        />
      );
    } else {
      return null;
    }
  }
}
